import { CustomIcon } from "components/icon/customIcon.component";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export interface StatusBannerProps {
  iconName: string;
  label: string;
  subLabel?: string;
  textColor?: ColorV2;
  backgroundColor?: ColorV2;
  fullWidth?: boolean;
}

const DEFAULT_HEIGHT = 110;
const DEFAULT_WIDTH = 936;

/** Status banner with icon, label, and sublabel. */
export const StatusBanner = ({
  iconName,
  label,
  subLabel,
  textColor = ColorV2.Blue1,
  backgroundColor = ColorV2.Blue7,
  fullWidth = false,
}: StatusBannerProps): JSX.Element => {
  return (
    <Wrapper
      $width={fullWidth ? undefined : DEFAULT_WIDTH}
      $background={backgroundColor}
    >
      <HeaderRow>
        <IconWrap>
          <CustomIcon name={iconName} size="24px" color={textColor} />
        </IconWrap>
        <Label $color={textColor}>{label}</Label>
      </HeaderRow>
      {subLabel && <SubLabel $color={textColor}>{subLabel}</SubLabel>}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $width?: number; $background: ColorV2 }>`
  width: ${(props) =>
    props.$width ? `min(100%, ${props.$width}px)` : "100%"};
  min-height: ${DEFAULT_HEIGHT}px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 16px;
  padding: 16px 24px;
  border-radius: 16px;
  background: ${(props) => props.$background};
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const Label = styled.span<{ $color: ColorV2 }>`
  ${TypographyV2.b1};
  color: ${(props) => props.$color};
`;

const SubLabel = styled.span<{ $color: ColorV2 }>`
  ${TypographyV2.s1};
  color: ${(props) => props.$color};
  margin-left: 36px;
`;
